import { useEffect } from 'react';

import _ from 'lodash';

import PropTypes from 'prop-types';

import RoomTypesPager from './room-types-pager.component';

import RoomTypesList from './room-types-list.component';

import RoomTypesFilters from './room-types-filters.component';

import NoResults from './no-results.component';

import useResponsive from '../../../utils/responsive';

const RoomTypes = (props) => {

    const { roomTypes, pageNumber, onAvailabilityChange, showNewFirst, allPortfolios } = props;

    const { isMobile, isTablet } = useResponsive();

    let filteredRooms = roomTypes;

    useEffect(() => {
        calculateAvailabilityCount(filteredRooms);
    });

    const calculateAvailabilityCount = (filteredRoomTypes) => {
        let totalAvailable = 0;
        _.forEach(filteredRoomTypes, (roomType) => {
            const numberAvailable = _.get(roomType, 'numberAvailable');
            const numberAvailableMales = _.get(roomType, 'numberAvailableForMales');
            const numberAvailableFemales = _.get(roomType, 'numberAvailableForFemales');
            if (numberAvailable) {
                totalAvailable += numberAvailable;
            } else if (numberAvailableMales && numberAvailableFemales) {
                totalAvailable += Math.ceil((numberAvailableMales + numberAvailableFemales) / 2);
            }
        });
        if (onAvailabilityChange) {
            onAvailabilityChange(totalAvailable);
        }
    };

    const renderRoomTypes = (filteredRoomTypes) => {

        if (!filteredRoomTypes || _.isEmpty(filteredRoomTypes)) {
            return <NoResults />;
        }

        return (
            <RoomTypesPager roomTypes={filteredRoomTypes} pageNumber={pageNumber}>
                {(paginatedRoomTypes) => (
                    <RoomTypesList
                        roomTypes={paginatedRoomTypes}
                        allPortfolios={allPortfolios}
                        isMobile={isMobile}
                        isTablet={isTablet}
                    />
                )}
            </RoomTypesPager>
        );
    };

    return (
        <RoomTypesFilters roomTypes={roomTypes} showNewFirst={showNewFirst}>
            {(filteredRoomTypes) => {
                filteredRooms = filteredRoomTypes;
                return renderRoomTypes(filteredRoomTypes);
            }}
        </RoomTypesFilters>
    );
};

export default RoomTypes;

RoomTypes.propTypes = {
    roomTypes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    pageNumber: PropTypes.number,
    showNewFirst: PropTypes.bool,
    allPortfolios: PropTypes.arrayOf(PropTypes.object),

    onAvailabilityChange: PropTypes.func,
};
